// Lightweight i18n scaffold — English at launch, structured for future locales.
import { createContext, useContext, useState } from "react";

const translations = {
  en: {
    appName: "TaperPath",
    tagline: "Taper safely. One gentle step at a time.",
    getHelpNow: "Get Help Now",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState("en");
  const t = (key) => translations[locale]?.[key] || translations.en[key] || key;
  return <I18nContext.Provider value={{ t, locale, setLocale }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
